
import { Component, Vue } from 'vue-property-decorator';

import Form9ProcessHeader from "@/components/process/Form9/components/Form9ProcessHeader.vue";
import Form9StyleOfProceeding from "@/components/process/Form9/components/Form9StyleOfProceeding.vue";
import { form9StatusInfoType } from '@/types/Information/Form9';

@Component({
    components:{
        Form9ProcessHeader,        
        Form9StyleOfProceeding
    }
})
export default class FillForm9 extends Vue {

    stepsCompleted = {} as form9StatusInfoType;   

    mounted() {  
        this.stepsCompleted = {
            first: false,
            second: false,
            third: false
        }       
    }
}
